import url from './url';



export default url(() => '/old-news/priority');
